/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invitees_Focus_TimeInputs */

const en_invitees_focus_time = /** @type {(inputs: Invitees_Focus_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Focus Time from Invites`)
};

const ar_invitees_focus_time = /** @type {(inputs: Invitees_Focus_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إجمالي وقت التركيز من الدعوات`)
};

const de_invitees_focus_time = /** @type {(inputs: Invitees_Focus_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamte Fokuszeit aus Einladungen`)
};

const es_invitees_focus_time = /** @type {(inputs: Invitees_Focus_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiempo total de concentración de invitados`)
};

const fr_invitees_focus_time = /** @type {(inputs: Invitees_Focus_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temps total de concentration des invités`)
};

const it_invitees_focus_time = /** @type {(inputs: Invitees_Focus_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo totale di concentrazione dagli inviti`)
};

const ja_invitees_focus_time = /** @type {(inputs: Invitees_Focus_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`招待からの合計集中時間`)
};

const ko_invitees_focus_time = /** @type {(inputs: Invitees_Focus_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`초대로 누적된 총 집중 시간`)
};

const pt_br_invitees_focus_time = /** @type {(inputs: Invitees_Focus_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo total de foco dos convites`)
};

const ru_invitees_focus_time = /** @type {(inputs: Invitees_Focus_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Общее время фокусировки по приглашениям`)
};

const th_invitees_focus_time = /** @type {(inputs: Invitees_Focus_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เวลาโฟกัสรวมจากคำเชิญ`)
};

const tr_invitees_focus_time = /** @type {(inputs: Invitees_Focus_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Davetlerden gelen toplam odaklanma süresi`)
};

const zh_cn_invitees_focus_time = /** @type {(inputs: Invitees_Focus_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`受邀者总专注时间`)
};

const zh_tw_invitees_focus_time = /** @type {(inputs: Invitees_Focus_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`受邀者總專注時間`)
};

/**
* | output |
* | --- |
* | "Total Focus Time from Invites" |
*
* @param {Invitees_Focus_TimeInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const invitees_focus_time = /** @type {((inputs?: Invitees_Focus_TimeInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invitees_Focus_TimeInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invitees_focus_time(inputs)
	if (locale === "ar") return ar_invitees_focus_time(inputs)
	if (locale === "de") return de_invitees_focus_time(inputs)
	if (locale === "es") return es_invitees_focus_time(inputs)
	if (locale === "fr") return fr_invitees_focus_time(inputs)
	if (locale === "it") return it_invitees_focus_time(inputs)
	if (locale === "ja") return ja_invitees_focus_time(inputs)
	if (locale === "ko") return ko_invitees_focus_time(inputs)
	if (locale === "pt_br") return pt_br_invitees_focus_time(inputs)
	if (locale === "ru") return ru_invitees_focus_time(inputs)
	if (locale === "th") return th_invitees_focus_time(inputs)
	if (locale === "tr") return tr_invitees_focus_time(inputs)
	if (locale === "zh_cn") return zh_cn_invitees_focus_time(inputs)
	return zh_tw_invitees_focus_time(inputs)
});